import { editFieldset } from './fieldset';

export default {
  title: 'Modifica Prodotto',
  elements: [
    {
      type: 'editForm',
      config: {
        actions: {
          fetch: {
            endpoint: 'products/{id}',
            method: 'GET',
            params: {
              expand: 'business__logo,main_image'
            }
          },
          save: {
            endpoint: 'products/{id}',
            method: 'PATCH'
          }
        },
        fieldsets: [editFieldset]
      }
    }
  ]
};
